// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-ff048974] .v-toolbar__content,[data-v-ff048974] .v-toolbar__extension {\n  padding: 8px 0px;\n}\n[data-v-ff048974] .v-dialog--scrollable > .v-card > .v-card__text,[data-v-ff048974] .v-dialog--scrollable > form > .v-card > .v-card__text {\n  overflow-y: hidden;\n}\n.email-dialog__content[data-v-ff048974] {\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
